import { render, staticRenderFns } from "./PersonDocumentComponent.vue?vue&type=template&id=216161f6"
import script from "./PersonDocumentComponent.vue?vue&type=script&lang=js"
export * from "./PersonDocumentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports